<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show
                :id="id"
                :models="models"
                model-def="automations"
                model-class="automation"
                :infos="infos"
                top-class=""
                :activities="true">
                <template slot="relations">
                    <belongstomany-show
                        class="pb-4"
                        :headers="infoData.fieldDefs"
                        title="Log Automazioni"
                        paginate
                        :url="'automationlogs-filters'"
                        :subFilters="{'automations': id}">
                    </belongstomany-show>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>

    import BelongstomanyShow from '@/components/common/BelongstomanyShow'

    export default {
        name: 'automation',
        components: {
            BelongstomanyShow
        },

        props: {
            id: Number,
        },

        data() {
            return {
                infos: {},
                models: {},
                relations: {},
                modelDef: 'automations',
                infoData: {},
            }
        },

        created() {
            this.axios.get(this.modelDef + '/' + this.id).then(response => {
                this.models = response.data.models
                this.infos = response.data.infos
                // this.relations = response.data.relations
                this.$store.commit('endProgress')
                this.load = true

            }, response => {
                // error callback
            })
            
            this.axios.get('automation-automationlogs-info').then(response => {
                this.infoData = response.data.info
            }, response => {
                // error callback
            })               
        }
    }
</script>
